import { CellContext } from '@tanstack/react-table';
import { FileFieldCell } from '@/components/table/_fieldDefinitions/file/FileFieldCell.tsx';
import { FileFieldCellDto } from '@/components/table/_fieldDefinitions/file/FileFieldCellDto.ts';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';

export const fileFieldRender = <T,>(info: CellContext<T, unknown>) => {
  const value = info.getValue() as FileFieldCellDto | null | undefined;
  if (!value || !value.fileId) return <EmptyValue />;
  return <FileFieldCell file={value} />;
};
